import { render, staticRenderFns } from "./HelloElasticVentures.vue?vue&type=template&id=1616752b&"
import script from "./HelloElasticVentures.vue?vue&type=script&lang=ts&"
export * from "./HelloElasticVentures.vue?vue&type=script&lang=ts&"
import style0 from "./HelloElasticVentures.vue?vue&type=style&index=0&id=1616752b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VContainer,VLayout,VParallax})
